<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div
    class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center"
    id="page-login"
  >
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" :style="'background-color:' + loginColor">
          <div class="vx-row no-gutter justify-center items-center">
            <div class="vx-col hidden lg:block lg:w-1/2">
              <img
                :src="logosUrl + 'login.png'"
                :alt="$t('Login')"
                class="mx-auto"
                style="max-width: 350px"
              />
            </div>

            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="px-8 pt-8">
                <div class="vx-card__title mb-4">
                  <h4 class="mb-4">{{ $t("Login") }}</h4>
                  <p>{{ $t("LoginInfo") }}</p>
                  <span>
                    <i18n />
                  </span>
                </div>
                <vs-input
                  v-validate="'required|min:3'"
                  data-vv-validate-on="blur"
                  name="companyno"
                  icon-no-border
                  icon="icon icon-user"
                  icon-pack="feather"
                  :label-placeholder="$t('CompanyNo')"
                  v-model="companyno"
                  class="w-full"
                />
                <span class="text-danger text-sm">{{ errors.first("companyno") }}</span>

                <vs-input
                  v-validate="'required|min:3'"
                  data-vv-validate-on="blur"
                  name="username"
                  icon-no-border
                  icon="icon icon-user"
                  icon-pack="feather"
                  :label-placeholder="$t('UserName')"
                  v-model="username"
                  class="w-full"
                />
                <span class="text-danger text-sm">{{ errors.first("username") }}</span>

                <vs-input
                  data-vv-validate-on="blur"
                  v-validate="'required|min:3'"
                  type="password"
                  name="password"
                  icon-no-border
                  icon="icon icon-lock"
                  icon-pack="feather"
                  :label-placeholder="$t('Password')"
                  v-model="password"
                  @keyup.enter="login()"
                  class="w-full mt-6"
                />
                <span class="text-danger text-sm">{{ errors.first("password") }}</span>
                <div class="flex flex-wrap justify-end mb-3" style="margin-top: 15px">
                  <b-button
                    class="bg-primary"
                    style="border-color: white"
                    v-on:click="login()"
                    >{{ $t("Login") }}
                    <Icon icon="material-symbols:login" width="20" height="20" />
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import { Validator } from "vee-validate";
import { Icon } from "@iconify/vue2";
import I18n from "../../../layouts/components/navbar/components/I18n.vue";
import router from "../../../router";
import userJson from "../../../../public/user.json";
export default {
  created() {
    const dict = {
      custom: {
        username: {
          required: this.$t("UsernameRequired"),
          alpha: this.$t("UsernameRequired"),
        },
        companyno: {
          required: this.$t("CompanynoRequired"),
          alpha: this.$t("CompanynoRequired"),
        },
        password: {
          required: this.$t("PasswordRequired"),
          alpha: this.$t("PasswordRequired"),
        },
      },
    };
    Validator.localize("tr", dict);
  },
  components: {
    I18n,
    Icon,
    Validator,
  },
  methods: {
    login() {
      var vs = this.$vs;
      const payload = {
        userDetails: {
          user: this.username,
          password: this.password,
          companyCode: this.companyno,
        },
        this: this,
        notify: this.$vs.notify,
        closeAnimation: this.$vs.loading.close,
      };
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$store
            .dispatch("auth/login", payload)
            .then(
              (response) => {
                if (response.status == 200) {
                  vs.notify({
                    iconPack: "feather",
                    color: "success",
                    icon: "icon-alert-circle",
                    title: this.$t("Success"),
                    text: this.$t("LoginSuccess"),
                  });
                  router.push("/");
                } else if (response.status == "401") {
                  vs.notify({
                    iconPack: "feather",
                    color: "warning",
                    icon: "icon-alert-circle",
                    title: this.$t("Error"),
                    text: this.$t("LoginUnauthorized"),
                  });
                }
              },
              (error) => {
                vs.notify({
                  iconPack: "feather",
                  color: "danger",
                  icon: "icon-alert-circle",
                  title: this.$t("Error"),
                  text: this.$t("NoConnection"),
                });
              }
            )
            .catch((err) => {
              console.log(err);
            });
        } else {
          vs.notify({
            text: this.$t("Validate"),
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "warning",
            position: "top-center",
          });
        }
      });
    },
  },
  data() {
    return {
      username: "",
      password: "",
      companyno: "",
      logosUrl: userJson.logosUrl,
      loginColor: userJson.loginColor,
    };
  },
};
</script>

<style lang="scss">
.login-tabs-container {
  min-height: 505px;

  .con-tab {
    padding-bottom: 14px;
  }

  .con-slot-tabs {
    margin-top: 1rem;
  }
}
</style>
